<div class="mobile-automation-container">
  <div class="content-wrapper">
    <div class="overview-header">
      <h1>Overview</h1>
      <div class="header-buttons">
        <button class="btn-outline" routerLink="/mobileAutomation/locator">Mobile Locator</button>
        <button class="btn-outline" routerLink="/mobileAutomation/instruction">Mobile Instruction</button>
      </div>
    </div>

    <div class="overview-description">
      <p>
        Mobile phones are gadgets characterized by applications that are unique in its quality requirements. While mobile applications were initially developed mostly in the entertainment sector, they are now touching more- critical domains intended to revolutionize the current payment system, to the m-government, and mobile-health initiative.
      </p>
      <p>
        Relay Mobile Automation offers speed, coverage, and usability to Adobe Engg / Service teams. It will aid development team to de-risk pipelines and enable reusability of mobile devices across Adobe and deliver seamless experience. For more information please refer the <a href="#" class="link">Wiki</a>.
      </p>
    </div>

    <h2 class="section-title">Explore the Transformative Features of Relay Mobile Automation</h2>

    <div class="features-grid">
      <!-- Key Offerings -->
      <div class="feature-card" (click)="toggleCard('key-offerings')">
        <div class="feature-card-inner" [ngClass]="{'flipped': flippedCards['key-offerings']}">
          <div class="feature-card-front">
            <div class="feature-icon">
              <img src="/assets/images/key-offerings-icon.png" alt="Key Offerings Icon" class="feature-icon-img">
            </div>
            <h3 class="feature-title">Core Features</h3>
            <p class="feature-card-hint">Click to see details</p>
          </div>
          <div class="feature-card-back">
            <h3 class="feature-title">Core Features</h3>
            <ul class="feature-list">
              <li>Codeless Automation</li>
              <li>Scheduled Test Executions</li>
              <li>Notifications (Slack & Mail)</li>
              <li>CI/CD Integration</li>
              <li>JIRA Integration</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Easy Configuration -->
      <div class="feature-card" (click)="toggleCard('easy-config')">
        <div class="feature-card-inner" [ngClass]="{'flipped': flippedCards['easy-config']}">
          <div class="feature-card-front">
            <div class="feature-icon">
              <img src="/assets/images/easy-config-icon.png" alt="Easy Configuration Icon" class="feature-icon-img">
            </div>
            <h3 class="feature-title">Configuration Simplicity</h3>
            <p class="feature-card-hint">Click to see details</p>
          </div>
          <div class="feature-card-back">
            <h3 class="feature-title">Configuration Simplicity</h3>
            <ul class="feature-list">
              <li>Test Data Driven: Extraction, Chaining, and Validation</li>
              <li>Post Operations</li>
              <li>Validation (Text and Image)</li>
              <li>Execution & Audit History</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Platform Support -->
      <div class="feature-card" (click)="toggleCard('platform-support')">
        <div class="feature-card-inner" [ngClass]="{'flipped': flippedCards['platform-support']}">
          <div class="feature-card-front">
            <div class="feature-icon">
              <img src="/assets/images/platform-support-icon.png" alt="Platform Support Icon" class="feature-icon-img">
            </div>
            <h3 class="feature-title">Platform Compatibility</h3>
            <p class="feature-card-hint">Click to see details</p>
          </div>
          <div class="feature-card-back">
            <h3 class="feature-title">Platform Compatibility</h3>
            <ul class="feature-list">
              <li>Android & iOS</li>
              <li>BYOD (Bring Your Own Device)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Second row of feature cards centered -->
    <div class="features-grid-centered">
      <!-- AI Integrations -->
      <div class="feature-card" (click)="toggleCard('ai-integrations')">
        <div class="feature-card-inner" [ngClass]="{'flipped': flippedCards['ai-integrations']}">
          <div class="feature-card-front">
            <div class="feature-icon">
              <img src="/assets/images/ai-integrations-icon.png" alt="AI Integrations Icon" class="feature-icon-img">
            </div>
            <h3 class="feature-title">AI-Driven Enhancements</h3>
            <p class="feature-card-hint">Click to see details</p>
          </div>
          <div class="feature-card-back">
            <h3 class="feature-title">AI-Driven Enhancements</h3>
            <ul class="feature-list">
              <li>Easy OCR: Text recognition</li>
              <li>OpenCV: Image recognition</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- What's Next? -->
      <div class="feature-card" (click)="toggleCard('whats-next')">
        <div class="feature-card-inner" [ngClass]="{'flipped': flippedCards['whats-next']}">
          <div class="feature-card-front">
            <div class="feature-icon">
              <img src="/assets/images/whats-next-icon.png" alt="What's Next Icon" class="feature-icon-img">
            </div>
            <h3 class="feature-title">Coming Soon</h3>
            <p class="feature-card-hint">Click to see details</p>
          </div>
          <div class="feature-card-back">
            <h3 class="feature-title">Coming Soon</h3>
            <ul class="feature-list">
              <li>Video of execution</li>
              <li>Record & Generate Test Cases</li>
              <li>Performance & Crash Reporting</li>
              <li>Code Coverage</li>
              <li>Enabling Localization</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Testcase Workflow Section -->
    <div class="testcase-workflow-section">
      <h2 class="section-title">Mobile Testcase Workflow</h2>

      <div class="workflow-container">
        <div class="workflow-step" [ngClass]="{'active': currentStep === 1, 'completed': currentStep > 1}">
          <div class="workflow-content">
            <div class="endpoint-layout">
              <h3 class="workflow-title">Step 1: Endpoint Layout</h3>
              <p class="workflow-description">The endpoint is the foundation of your test automation, combining multiple instructions to form a cohesive workflow.</p>
              <div class="endpoint-diagram">
                <div class="endpoint-box">
                  <h4>Endpoint</h4>
                  <div class="instruction-list">
                    <div class="instruction-item">Instruction 1</div>
                    <div class="instruction-item">Instruction 2</div>
                    <div class="instruction-item">Instruction 3</div>
                    <div class="instruction-item">Instruction 4</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="workflow-step" [ngClass]="{'active': currentStep === 2, 'completed': currentStep > 2}">
          <div class="workflow-content">
            <div class="instruction-layout">
              <h3 class="workflow-title">Step 2: Instruction 1</h3>
              <p class="workflow-description">Tap on Menu Button</p>
              <div class="instruction-diagram">
                <div class="action-locator-container">
                  <div class="action-box">
                    <h4>ACTION</h4>
                    <div class="action-highlight">Tap</div>
                    <ul class="action-list">
                      <li>Launch App</li>
                      <li>Enter Text</li>
                      <li>Swipe</li>
                      <li>Long Press</li>
                      <li>Verify Element</li>
                    </ul>
                  </div>

                  <div class="plus-sign">+</div>

                  <div class="locator-box">
                    <h4>LOCATOR</h4>
                    <div class="locator-highlight">Accessibility ID: "menu_button"</div>
                    <ul class="locator-list">
                      <li>ID</li>
                      <li>XPath</li>
                      <li>Text</li>
                      <li>Image</li>
                      <li>Class Name</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="workflow-step" [ngClass]="{'active': currentStep === 3, 'completed': currentStep > 3}">
          <div class="workflow-content">
            <div class="instruction-layout">
              <h3 class="workflow-title">Step 3: Instruction 2</h3>
              <p class="workflow-description">Tap on Settings Option</p>
              <div class="instruction-diagram">
                <div class="action-locator-container">
                  <div class="action-box">
                    <h4>ACTION</h4>
                    <div class="action-highlight">Tap</div>
                    <ul class="action-list">
                      <li>Launch App</li>
                      <li>Enter Text</li>
                      <li>Swipe</li>
                      <li>Long Press</li>
                      <li>Verify Element</li>
                    </ul>
                  </div>

                  <div class="plus-sign">+</div>

                  <div class="locator-box">
                    <h4>LOCATOR</h4>
                    <div class="locator-highlight">Text: "Settings"</div>
                    <ul class="locator-list">
                      <li>ID</li>
                      <li>XPath</li>
                      <li>Accessibility ID</li>
                      <li>Image</li>
                      <li>Class Name</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="workflow-step" [ngClass]="{'active': currentStep === 4, 'completed': currentStep > 4}">
          <div class="workflow-content">
            <div class="instruction-layout">
              <h3 class="workflow-title">Step 4: Instruction 3</h3>
              <p class="workflow-description">Input Text in Search Field</p>
              <div class="instruction-diagram">
                <div class="action-locator-container">
                  <div class="action-box">
                    <h4>ACTION</h4>
                    <div class="action-highlight">Enter Text</div>
                    <ul class="action-list">
                      <li>Launch App</li>
                      <li>Tap</li>
                      <li>Swipe</li>
                      <li>Long Press</li>
                      <li>Verify Element</li>
                    </ul>
                  </div>

                  <div class="plus-sign">+</div>

                  <div class="locator-box">
                    <h4>LOCATOR</h4>
                    <div class="locator-highlight">ID: "search_input_field"</div>
                    <ul class="locator-list">
                      <li>XPath</li>
                      <li>Text</li>
                      <li>Accessibility ID</li>
                      <li>Image</li>
                      <li>Class Name</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="workflow-step" [ngClass]="{'active': currentStep === 5}">
          <div class="workflow-content">
            <div class="endpoint-layout">
              <h3 class="workflow-title">Mobile Endpoint Complete</h3>
              <p class="workflow-description">All instructions combine to form a complete Mobile Endpoint.</p>
              <div class="endpoint-diagram">
                <div class="endpoint-box completed-endpoint">
                  <h4>Mobile Endpoint</h4>
                  <div class="instruction-list">
                    <div class="instruction-item">Tap on Menu Button</div>
                    <div class="instruction-item">Tap on Settings Option</div>
                    <div class="instruction-item">Input Text in Search Field</div>
                    <div class="instruction-item">+ More Instructions...</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Navigation buttons -->
        <div class="workflow-navigation">
          <button [disabled]="currentStep === 1" class="nav-button prev-button" (click)="prevStep()">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <div class="step-indicator">
            <span *ngFor="let step of [1,2,3,4,5]; let i = index"
                  class="step-dot"
                  [ngClass]="{'active': currentStep === i+1, 'completed': currentStep > i+1}"
                  (click)="goToStep(i+1)">
            </span>
          </div>
          <button [disabled]="currentStep === 5" class="nav-button next-button" (click)="nextStep()">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="products-section">
      <h2 class="section-title">Products using Mobile Automation</h2>

      <div class="product-rows">
        <!-- Row 1: Android+iOS products -->
        <div class="product-row">
          <div class="product-slide" *ngFor="let product of getProductsByPlatform(['android', 'ios'])">
            <div class="product-card" [style.border-color]="product.color">
              <div class="product-logo-container" [style.background-color]="product.color">
                <img [src]="product.logoPath" [alt]="product.name + ' logo'" class="product-logo">
              </div>
              <div class="product-name">
                {{product.name}}
                <span class="product-subheading" *ngIf="product.subheading">{{product.subheading}}</span>
              </div>
              <div class="platforms">
                <img src="./assets/images/android.png" class="platform-icon" title="Android Support">
                <img src="./assets/images/mac.png" class="platform-icon" title="iOS Support">
              </div>
              <div class="product-hover-overlay" [style.background-color]="product.color">
                <div class="product-hover-content">
                  <img [src]="product.logoPath" [alt]="product.name + ' logo'" class="product-logo-hover mb-2">
                  <div>{{product.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Android-only products -->
        <div class="product-row">
          <div class="product-slide" *ngFor="let product of getProductsByPlatform(['android'])">
            <div class="product-card" [style.border-color]="product.color">
              <div class="product-logo-container" [style.background-color]="product.color">
                <img [src]="product.logoPath" [alt]="product.name + ' logo'" class="product-logo">
              </div>
              <div class="product-name">
                {{product.name}}
                <span class="product-subheading" *ngIf="product.subheading">{{product.subheading}}</span>
              </div>
              <div class="platforms">
                <img src="./assets/images/android.png" class="platform-icon" title="Android Support">
              </div>
              <div class="product-hover-overlay" [style.background-color]="product.color">
                <div class="product-hover-content">
                  <img [src]="product.logoPath" [alt]="product.name + ' logo'" class="product-logo-hover mb-2">
                  <div>{{product.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>